export default __webpack_public_path__ + "static/media/harshit-story.457caf35.png";